import React from "react";
import { toPersian } from "../../Utility/Utilities";
const colors = { red: "red", normal: "rgb(9, 68, 128)" };
const shadows = {
  red: "rgba(255, 0, 0, 0.3)",
  normal: "rgba(9, 68, 128,1)",
};
const CircularChart = ({ value, maxValue, status, onDisabled }) => {
  const radius = 50; // شعاع دایره
  const circumference = 2 * Math.PI * radius; // محیط دایره
  const progress = (value / maxValue) * circumference; // محاسبه مقدار پیشرفت

  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 150 150"
      style={{ transform: "rotate(-90deg)" }}
    >
      {/* تعریف گرادیان سایه */}
      {/* <defs>
        <radialGradient id="gradient-shadow" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={shadows[status]} />
          <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
        </radialGradient>
      </defs> */}

      {/* دایره پس‌زمینه */}
      <circle
        cx="75"
        cy="75"
        r={radius}
        fill="transparent"
        stroke="#e6e6e6"
        strokeWidth="12"
      />

      {/* دایره سایه گرادیانی */}
      <circle
        cx="75"
        cy="75"
        r={radius + 10}
        fill="url(#gradient-shadow)"
        stroke="none"
        style={{
          opacity: 0.7,
        }}
      />

      {/* دایره پیشرفت */}
      <circle
        cx="75"
        cy="75"
        r={radius}
        fill="transparent"
        stroke={colors[status]}
        strokeWidth="10"
        strokeDasharray={circumference}
        strokeDashoffset={circumference - progress}
        style={{
          transition: "stroke-dashoffset 0.5s ease",
        }}
      />

      {/* متن در مرکز */}
      <text
        x="78"
        y="-68"
        textAnchor="middle"
        fontSize="20px"
        fontFamily="regular"
        fill={onDisabled ? "#fff" : "#333"}
        style={{ transform: "rotate(90deg)" }}
      >
        {toPersian(Math.round((value / maxValue) * 100))}%
      </text>
    </svg>
  );
};

export default CircularChart;
